import React, { useState, useEffect } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import Button from "../Button";

export default function AddSamplesToJob({ sampleIds, closeForm }) {
  const [jobs, setJobs] = useState(null);
  const [selectedJobId, setSelectedJobId] = useState(null);

  const fetchJobs = () => {
    fetchJson("/jobs/jobs.json", { sample_ids: sampleIds }).then((json) => {
      if (json.errors) {
        alert(json.errors);
        closeForm();
      } else {
        setJobs(json);
      }
    });
  };

  const handleAddToJob = () => {
    if (sampleIds.length === 0 || !setSelectedJobId) return;

    if (
      !confirm(
        "Are you sure you want to add the selected samples to job " + selectedJobId + "?"
      )
    ) {
      return;
    }

    post("/jobs/jobs/" + selectedJobId + "/add_samples.json", { sample_ids: sampleIds })
      .then((json) => {
        alert("Samples were successfully added.");
        closeForm();
      })
      .catch((errors) => alert(errors));
  };

  useEffect(
    () => {
      fetchJobs();
    },
    [sampleIds]
  );

  if (!jobs)
    return (
      <div className="basic-panel with-padding">
        <i className="fa fa-refresh fa-spin fa-spin" />
        &nbsp; Loading Jobs...
      </div>
    );

  return (
    <div className="basic-panel with-padding">
      <table className="table table-condensed">
        <thead>
          <tr>
            <th style={{ width: 30 }} />
            <th>Job Id</th>
            <th>State</th>
            <th>Created At</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((job) => (
            <tr>
              <td>
                <input
                  type="radio"
                  name="job_id"
                  checked={selectedJobId === job.id}
                  onChange={(e) => setSelectedJobId(job.id)}
                />
              </td>
              <td>{job.id}</td>
              <td>{job.state_name}</td>
              <td>{job.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Button
        title="Add To Selected Job"
        disabled={!selectedJobId || sampleIds.length === 0}
        onClick={handleAddToJob}
      />
    </div>
  );
}
